module.exports = __webpack_public_path__ + "media/images/core_values/custom_value-7203c387bb58922dc1386433820b63b0.png";